export const findElement = (elementIdOrClass: string) => {
  if (elementIdOrClass[0] === ".")
    return document.getElementsByClassName(
      elementIdOrClass.slice(1),
    )[0] as HTMLElement;
  if (elementIdOrClass[0] === "#")
    return document.getElementById(elementIdOrClass.slice(1));
  let targetElement: HTMLElement | null =
    document.getElementById(elementIdOrClass);
  if (!targetElement)
    targetElement = document.getElementsByClassName(
      elementIdOrClass,
    )[0] as HTMLElement;
  return targetElement;
};
